type HomePageSectionProps = {
  children: React.ReactNode;
  title?: string;
  viewAllLink?: string;
  textColor?: string;
  dataTestId?: string;
  additionalClasses?: string;
  alignEnd?: boolean;
  justifyCenter?: boolean;
  useGap?: boolean;
  rowVerticalAlign?: string;
  id?: string;
};

export function HomePageSection({
  children,
  title,
  viewAllLink,
  textColor,
  dataTestId,
  additionalClasses,
  alignEnd,
  justifyCenter,
  useGap,
  rowVerticalAlign,
  id,
}: HomePageSectionProps) {
  const vAlignment = (() => {
    switch (rowVerticalAlign) {
      case 'top':
        return 'align-items-start';
      case 'center':
        return 'align-items-center';
      case 'bottom':
        return 'align-items-end';
      default:
        return '';
    }
  })();

  const rowClasses = [
    'row',
    vAlignment,
    alignEnd ? 'align-items-end' : '',
    justifyCenter ? 'justify-content-center' : '',
    useGap ? 'gap-main' : 'mx-0',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={`home-section-container ${additionalClasses || ''}`}
      data-testid={dataTestId}
    >
      {title && (
        <div className="row justify-content-between mx-0">
          <h2
            style={{ color: textColor }}
            data-testid="homepage-section-title"
            {...(id ? { id } : {})}
          >
            {title}
          </h2>
          {viewAllLink && (
            <a
              href={viewAllLink}
              style={{ color: textColor }}
              data-testid="homepage-section-view-all-link"
              aria-describedby={`${id}`}
            >
              View all
            </a>
          )}
        </div>
      )}

      <div
        className={`home-section-body ${rowClasses}`}
        data-testid="homepage-section-body"
      >
        {children}
      </div>
    </div>
  );
}
